import {useNavigate} from "react-router-dom";
import SnackError from "../../components/SnackError";
import React from "react";
import {IntrApiPut, usePostInterruptMutation} from "./intr_api";
import IntrForm from "./IntrForm";
import {Card, CardContent} from "@mui/material";
import Title from "../navigation/Title";


export const IntrCreate = () => {

    const [post, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePostInterruptMutation();
    const navigate = useNavigate();
    const handleSubmit = async function (values: IntrApiPut) {
        const resp = await post(values)
        if ("data" in resp) {
            navigate("..", {replace:true})
        }
    };

    return <>
        <Title title={"Nova vrsta prekinitve"}/>
        <Card sx={{mt: "2em"}}>
            {isError && <SnackError error={error}/>}
            <CardContent>
                <IntrForm
                    isUpdating={isUpdating}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate("..", {replace: true})}
                    object={{Name: "", Code: "", Timeout: 0, Active: true}}
                />
            </CardContent>
        </Card>
    </>;
}
